<template>
<div class="pop pos-f top0 bottom0 left0 right0" id="skuPanel" style="display: none;" v-show="showSkuDom"
     @touchmove.prevent.stop="disabledTouchMove">
	<div class="bg-white pos-f bottom0 left0 right0 skuPandel_main">
		<div class="flex-container left pos-r padding20" style="padding-top: 0">
			<div @click="skuImgClick" class="overflow-h borderR8" style="border: 1px solid #e8e8e8">
				<img :onerror="errorHandler" :src="imgUrl" class="border-radius border" width="90" height="90" alt="">
			</div>
			<div class="marginl20 margint20">
				<ul class="fs-12">
                    <li class="text-darker">
                        <div class="dis-i fs-14 text-red" v-if="!!probablyPrice && !!price" style="margin-right: 12px">
                            预估到手
                            <span class="fs-15">¥</span>
                            <span v-text="probablyPrice" class="text-bolder" style="font-size: 28px"></span>
                        </div>
                        <div class="fs-20 dis-i bg-vip-price" v-if="!!vipPrice && !!price">
                            <img src="//image1.51tiangou.com/tgou2/img2/giftCard/up-logo.png" alt=""
                                 width="24" style="vertical-align: baseline;">
                            <span class="fs-12">¥</span><span v-text="vipPrice" class="fs-16"></span>
                        </div>
                        <div :class="[(!!probablyPrice || !!vipPrice) && !!price ? 'fs-14': 'fs-20', 'text-red']">
                            <span v-if="(!!probablyPrice || !!vipPrice)&& !!price">天狗价：</span>
                            <span class="fs-15">¥</span>{{ price || priceText }}
                        </div>
                    </li>
					<li><span v-text="remainText"></span></li>
					<li>
						<span v-show="chooseTag || skuTags.length" v-text="chooseText"></span>
						<span class="marginr10" v-for="item in (chooseTag || skuTags)" v-text="item"></span>
					</li>
				</ul>
			</div>
			<span class="icon-close fs-18 pos-a right0"
                  style="top: -20px;right: 8px"
                  @click="closeSku(true)"></span>
		</div>
		<div class="padding50" v-if="loading">
			<tg-loadding v-if="loading"></tg-loadding>
		</div>
        <div style="height: 8px;width: 100%;background: #f7f7f7"></div>
        <tg-relation-sku :sku="sku" :num="showNum" class="sku" :relation-items="relationItems" :item-id="itemId"
                :limit="limit" :price-limit="priceLimitNum" v-if="relationItems.length"></tg-relation-sku>
        <tg-sku :sku="sku" :num="showNum" class="sku"
                :limit="limit" :price-limit="priceLimitNum" v-else
                :depot="depot && source === 1"></tg-sku>
		<div v-if="tax || taxAmount" class="margint10 fs-12 text-light padding20" @click="fold">
			<span v-text="taxText"></span>
			<span class="text-darker" v-if="!(taxType === 0 && taxCount < 50)" v-text="'¥'+ taxCount"></span>
			<span class="text-darker" v-else>
				<del class="text-darker" v-text="'¥'+ taxCount"></del>
				(<span class="text-green">关税≤50,免征收</span>)
			</span>
			<i class="fs-14"
			   style="vertical-align: middle;"
			   v-if="!(taxType === 0 && taxCount < 50)" :class="!isFold ? 'icon-unfold' : 'icon-fold'"></i>
			<div style="background: #ededed;"
				 class="text-darker padding20"
				 v-if="!(taxType === 0 && taxCount < 50)"
				 v-show="isFold">此税费为预估金额，结算税费以提交订单时应付总额明细为准</div>
		</div>
		<div class="fs-11 text-center text-dark skuStoreName flex-container left top paddingl20 bordert paddingt30"
             v-if="depot"
             v-html="newStoreName"></div>
	</div>

    <div class="hei flex-container pos-f bottom0 left0 box-container fs-15 btn-confirm"
         :class="state ? 'text-light': (skuItem && skuItem.ext && !skuItem.data) ? 'text-light':'bg-red text-white'"
         :style="state ? 'background-color:#f7f7f7;': (skuItem && skuItem.ext && !skuItem.data) ? 'background-color:#f7f7f7;':''"
         v-if="useType==='choose'"
         @click="confirm"
         data-scp="skuOk.00"
         :data-bk="'item-'+itemId"
         v-text="state?btnText[state]:'确认'">
    </div>
    <!-- 查看相似商品 -->
    <a v-if="state==='findSimilar'"
       :href="findSimilarUrl"
       data-scp="skuSimilar.00">
        <div class="hei flex-container pos-f bottom0 left0 box-container text-white fs-15 bg-orange">查看相似商品</div>
    </a>

    <!-- 购物车 立即购买 -->
    <div class="flex-container center pos-f bottom0 right0 left0 text-white fs-15"
         style="margin: 0 12px 20px"
         v-if="!state && useType==='buy'">
        <div class="flex1 text-center text-red"
             style="background-color:#fff1f2;line-height: 1.32rem;border-radius: 1.32rem;margin-right: 8px"
             @click="addToCart"
             :data-bk="'item-'+itemId"
             v-if="!disabled"
             data-scp="addCar.00" v-html="cartBtnContent"></div>
        <div class="flex1 flex-container flex-container-col round center borderr"
             style="background-color: rgb(153, 153, 153);height: 1.32rem;"
             data-scp="addCar.00"
             :data-bk="'item-'+itemId"
             v-else
             v-html="cartBtnContent"></div>
        <div class="flex1 flex-container flex-container-col round bg-red center"
             style="height: 1.32rem;border-radius: 1.32rem;"
             v-if="!disabled"
             @click="buy"
             :data-bk="'item-'+itemId"
             data-scp="buy.00"  v-html="mainBtnContent"></div>
        <div class="flex1 flex-container flex-container-col round center"
             style="height: 1.32rem;background-color: rgb(153, 153, 153);"
             v-else
             data-scp="buy.00" :data-bk="'item-'+itemId" v-html="mainBtnContent"></div>
    </div>
    <!-- 只有 立即购买 -->
    <div class="flex-container pos-f bottom0 left0 box-container text-white fs-15"
         style="margin: 12px;width: calc(100% - 24px)"
         v-if="!state && useType==='buyOnly'">
        <span class="dis-b span12 text-center bg-red"
              style="height: 1.32rem;line-height: 1.32rem;background: linear-gradient(134deg,#ff2674 0%,#ff2238 100%);border-radius: 1.32rem"
              @click="buy" data-scp="skuOk.00" :data-bk="'item-'+itemId" v-html="mainBtnContent"></span>
    </div>
    <div class="mask" v-if="loadingR">
        <tg-loadding v-if="loadingR" class="pos-a" style="left: 50%;transform: translateX(-50%);"></tg-loadding>
    </div>
</div>
</template>

<style lang="scss">
.borderR8 {
    border-radius: 8px;
}
.pop{
	width:100%;
	height:100%;
	background-color: rgba(0,0,0,.6);
	z-index:8;
}
.pop .hei{
	height:1.32rem;
	line-height:1.32rem;
}
.pop .hei span{
	height:100%;
}
.pop .disabled{
	color:#ccc !important;
}
.sku dl:last-child{
		border-bottom: 0;
}
.sku .badge {
	padding: 2px 7px;
}
.sku .badge.badge-reverse {
	padding: 1px 6px;
}
.sku .badge.badge-reverse.badge-black {
	border: 1px solid #999;
	color:#222;
}
.skuPandel_main {
	padding-bottom: 75px;
    padding-top: 37px;
	min-height:38%;
}
.tg-alert{
	z-index: 100 !important;
}
.skuStoreName{
	bottom: 1.32rem; margin-bottom:4px;
}
.bg-vip-price {
    padding: 0 4px;
    background: #fff6df;
    color: #a77944;
    line-height: 24px;
    border-radius: 4px;
}
.btn-confirm {
    margin: 0 12px 20px;
    width: calc(100% - 24px);
    border-radius: 1.32rem;
}
.btn-confirm.bg-red {
    background: #ff2238;
}
</style>

<script>
import maple     from 'maple';
import $         from 'jquery';
import domain    from '../domain.js';
import '../component/loadding/index.js';
import '../component/sku/index.js';
import {request} from '../http.js';
import order     from '../api/order.js';
import {api} from 'tgPage';

const MAX_PRICE_EFFECT_TAX_TYPE = [
		0		// 行邮税
		, 1		// 综合税
	];

export default {
	el: 'tg-sku-panel',
    data: {
		showSkuDom: false
		, skuComplete: false
		, skuTags: []
		, skuNum: 1		// 选择数量
		, skuNumLast: 1	// 上次选择数量
		, tax: 0		// 税率
		, taxType: null	// 税类型

		, hasTax: false	// 是否有税率
		, bondedItem: false	// 是否为保税商品
		, groupItem: false	// 是否为组合品
		, taxAmount: 0	// 税费

		, storeId: ''

		, imgUrl: ''
		, mainImgUrl: ''	// 商品主图
		, showPriceKey: 'price'
		, price: ''		// 当前 sku 价格
        , vipPrice: '' // upvip 价格
        , newer: false // 是否新人
        , vipPrice_bac: '' // upvip 价格
		, minPrice: ''
		, maxPrice: ''	// 当前商品最高价
		, minSkuPrice: ''	// 非专柜团最低价
		, maxSkuPrice: ''	// 非专柜团最高价
//		, allPrice: ''	// 商品价格区间
		, remain: ''	// 当前 sku 库存
		, allRemain: ''	// 商品总库存
		, buyerShowId: ''
		, itemId: ''	// 商品 id
		, productId: ''	//
		, storeName: ''	// 商品门店
		, loading: true	// 显示加载中
		, useType: 'choose'	// 使用类型
		, showNum: false	// 是否显示数量选择
		, state: ''			// 商品状态
		, depot: true		// 同品多仓
		, counterGroup: false	// 专柜团
		, getSku: false
		// , skuState:
		, btnText: {
			offshelf: '商品已下架'
			, deleted: '商品已下架'
			, zero: '库存不足'
			, getData: '确认'
			, findSimilar: '查看相似商品'
			, soldOut: '已售光'
		}
		, findSimilarUrl: ''
		, chooseTag: null
		, returnChooseTag: null
		, limit: 0	// 限购数量
		, limitOriginal: 0	// 本门店的限购数量
		, errImg: '//image1.51tiangou.com/tgou2/img2/fitting/defaultFittingListPic.png'
		, priceLimit: Infinity	// 最大购买金额
		, priceLimitNum: 0			// 最大购买金额限购数量

		, isFold: false	// 税费下的提示文字是否展开

		, mainBtnContent: '立即购买'
		, mainBtnText: '立即购买'
		, cartBtnContent: '加入购物车'

		, disabled: false

		, activityId: undefined
		, groupShow: undefined
        , isVip: false,
        source: 0,
        // 预估到手价
        probablyPrice: 0,
        relationItems: [],
        // 关联商品
        btnList: {},
        skuItem: {},
        loadingR: false
	}
	, methods: {
		/**
		 * 显示 skuPanel
		 * @param	{Object?}	sku		商品的 sku 数据以及相关数据
		 * @param	{Number}	sku.price	商品价格
		 * @param	{String}	sku.state	商品状态
		 * @param	{String}	sku.imageUrl	商品图片
		 * @param	{Array}		sku.items	sku 数据
		 * @desc
		 * 	目前有四种类型：
		 * 		offshelf	商品已下架
		 * 		deleted		商品已下架
		 * 		zero		商品库存不足（zero 为内部计算得出）
		 * 		空			商品状态正常
		 * @todo	接受 Promise 类型的 sku 参数
		 * */
		showSku: function(sku){
			if( sku ){
				this.setSku( sku );
			}
			else if( this.sku ){
			}
			else{
				this.loading = true;
			}

			this.showSkuDom = true;
		}
		/**
		 * 隐藏 skuPanel
		 * */
		, closeSku: function(emit){
			this.showSkuDom = false;
			$('body')[0].style.overflow = 'auto';

			emit && this.$emit('closeSku', this.skuId, this.skuComplete ? this.returnChooseTag : this.skuTags, this.skuItem, this.skuNum || 1);
		}
		/**
		 * 设置 sku 数据
		 * @param	{Object}		sku				商品的 sku 数据以及相关数据
		 * @param	{Number}		sku.price		商品价格
		 * @param	{Number}		sku.maxPrice	商品价格区间最大值
		 * @param	{Number}		sku.minSkuPrice
		 * @param	{Number}		sku.maxSkuPrice
		 * @param	{String}		sku.state		商品状态
		 * @param	{Number}		sku.remain		商品总库存
		 * @param	{String}		sku.imageUrl	商品图片
		 * @param	{Array}			sku.items		sku 数据
		 * @desc
		 * 	目前有四种类型：
		 * 		offshelf	商品已下架
		 * 		deleted		商品已下架
		 * 		zero		商品库存不足（zero 为内部计算得出）
		 * 		空			商品状态正常
		 * */
		, setSku: function(sku, activityId, groupShow, isVip){
			var state = sku.state;

			this.loading = false;

			// 设置商品状态
			if( state === 'offshelf' || state === 'deleted' ){
				this.$set('state', state);
			} else{
				if( sku.items.length ){
					this.$set('state', '');
				}
				else{
					this.$set('state', 'zero');
				}
			}
            if (this.relationItems.length && this.disabled && Object.keys(this.btnList).length !== 0) {
                if (this.btnList.mainBtn.content === '已下架') {
                    this.$set('state', 'offshelf');
                } else if (this.btnList.mainBtn.content === '已售光') {
                    this.$set('state', 'soldOut');
                }
            }

			this.$set('sku', sku);
			this.$set('imgUrl', domain.getImageUrl(sku.imageUrl));
			this.$set('mainImgUrl', domain.getImageUrl(sku.imageUrl));
			this.$set('minPrice', sku.price );
			sku.maxPrice && this.$set('maxPrice', sku.maxPrice);
			sku.minSkuPrice && this.$set('minSkuPrice', sku.minSkuPrice);
			sku.maxSkuPrice && this.$set('maxSkuPrice', sku.maxSkuPrice);
			this.$set('vipPrice', sku.vipPrice);
			this.$set('newer', sku.newer);
			this.$set('vipPrice_bac', sku.vipPrice);
//			this.$set('allPrice', sku.price );
			this.$set('remain', sku.remain);
			this.$set('allRemain', sku.remain);
			this.$set('isVip', isVip)

			this.activityId = activityId;
			this.groupShow = groupShow;
		}
		/**
		 * 获取当前所选择的数据信息，即 skuTags
		 * */
		, getSkuTags: function(){
			return this.skuTags;
		}
		, getChooseValue(){
			return this.returnChooseTag;
		}

		/**
		 * 设置使用方式，是仅选择 sku，还是可购买
		 * @param	{String}	type	使用方式
		 * @desc
		 * 	目前有两种种类型：
		 * 		choose	商品选择状态，skuPanel 显示 确认 按钮
		 * 		buy		商品购买状态，skuPanel 显示 加入购物车 和 立即购买 两个按钮
		 * */
		, setUseType: function(type){
			this.useType = type;
		}
		/**
		 * 设置是否显示数量选择
		 * @param	{Boolean}	show	是否显示数量选择
		 * */
		, setShowNum: function(show){
			this.showNum = !!show;
		}
		/**
		 * 设置 loading 状态，重置 skuPanel 时使用
		 * @param	{Boolean}	isLoading	设置 loading 状态
		 * */
		, setLoading: function(isLoading){
			this.loading = !!isLoading;
		}
		/**
		 * 确认按钮触发方法，将会触发自身的 confirm 事件并传入 skuId skuTags skuItem，其中 confirm 方法应在外部实现
		 * */
		, confirm: function() {
            if (this.disabled) {
                return ;
            }
			if(this.skuComplete && this.state === '' && !this.getSku && this.skuItem && (!this.skuItem.ext || (this.skuItem.ext && this.skuItem.data))){
				this.$emit('confirm', this.skuId, this.skuTags, this.skuItem, this.skuNum || 1);
			}
			else{
				maple.notice('请选择商品属性！');
				return false;
			}
		}
		/**
		 * 确认按钮触发方法，将会触发自身的 buy 事件并传入 skuId，其中 buy 方法应在外部实现
		 * */
		, buy: function(){
			if( this.skuComplete && this.state === '' && !this.getSku && this.skuItem && (!this.skuItem.ext || (this.skuItem.ext && this.skuItem.data)) ){
				this.$emit('buy', this.skuId, this.skuTags, this.skuItem, this.skuNum || 1);
			}
			else{
				maple.notice('请选择商品属性！');
				return false;
			}
		}
		/**
		 * 确认按钮触发方法，将会触发自身的 addToCart 事件并传入 skuId，其中 addToCart 方法应在外部实现
		 * */
		, addToCart: function(){
			if( this.skuComplete && this.state === '' && !this.getSku && this.skuItem && (!this.skuItem.ext || (this.skuItem.ext && this.skuItem.data)) ){
				this.$emit('addToCart', this.skuId, this.skuTags, this.skuItem, this.skuNum || 1);
			}
			else{
				maple.notice('请选择商品属性！');
				return false;
			}
		}

		, setShowPriceKey(key){
			this.showPriceKey = key;
		}

		, setErrImg(src){
			this.errImg = src;
		}
		/**
		 * 设置税率、税费类型、限购金额
		 * @param	{Number}	tax		税率
		 * @param	{Number}	taxType	税率类型：0 行邮税，1 综合税，2 销项税
		 * @param	{Number}	price	限购价格（只有 MAX_PRICE_EFFECT_TAX_TYPE 中有的类型受影响）
		 * */
		, setTax(tax, taxType, priceLimit){
			this.tax = tax;
			this.taxType = taxType;
			this.priceLimit = priceLimit;
		}

		/**
		 * 设置是否保税商品税率
		 * @param	{boolean}	hasTax		是否有税率
		 * @param	{boolean}	bondedItem	是否保税商品标识
		 * @param	{boolean}	groupItem	是否是组合品
		 * */
		, setBondedTax(hasTax, bondedItem, groupItem){
			this.hasTax = hasTax;
			this.bondedItem = bondedItem;
			this.groupItem = groupItem;
		}
		/**
		 * 设置 storeId
		 * @param	{string|number}	storeId
		 * */
		, setStoreId(storeId){
			this.storeId = storeId;
		}

		/**
		 * 设置限购数量
		 * */
		, setLimit(limit){
			this.limit = limit;
			this.limitOriginal = limit;
		}
		/**
		 * 设置 itemId
		 * */
		, setItemId(itemId){
			this.itemId = itemId;
		}
		/**
		 * 设置 productId
		 * */
		, setProductId(productId){
			this.productId = productId;
		}
		/**
		 * 设置提供商
		 * */
		, setStoreName(storeName){
			this.storeName = storeName;
		}
		/**
		 * 设置
		 * */
		, setDepot(depot){
			this.depot = depot;
		}

        /**
         * 设置 source
         * */
        , setSource(source){
            this.source = source;
        }

		/**
		 * 设置为专柜团
		 * */
		, setCounterGroup(counterGroup){
			this.counterGroup = counterGroup;
		}

		, skuImgClick(){
			this.$dispatch('skuImgClick', this.imgUrl);
		}

        , relationImgClick(imgUrl){
            this.$dispatch('relationImgClick', imgUrl);
        }

		, fold(){
			this.isFold = !this.isFold;
		}

		, setMainBtnContent(text, mainBtnText){
			this.mainBtnContent = text;
			this.mainBtnText = mainBtnText;
		}
		, setCartBtnContent(text){
			this.cartBtnContent = text;
		}

		, disabledTouchMove(){}

		, setDisabled(disabled){
			this.disabled = disabled;
		},
        requestProbablyPrice() {
            const that = this;
            api.item.getProbablyPrice({
                data: {
                    itemId: this.itemId,
                    skuId: this.skuId
                },
                success(data){
                    if (data) {
                        that.probablyPrice = data;
                    }
                }
            });
        },
        setRelationItems(items) {
            this.relationItems = items;
        },
        // 点立即购买时默认选中第一个库存不为0的sku
        chooseDefault(callback) {
            let tgSkulVm = null;
            if (this.$children) {
                tgSkulVm = this.$children.filter((item) => {
                    return item.$options.name === 'tg-sku';
                })[0];
            }
            if (!this.chooseTag) {
                for (let i = 0; i < this.sku.items.length; i++) {
                    if (this.sku.items[i].remainQty !== -1 && this.sku.items[i].remainQty !== 0) {
                        for (let key in this.sku.items[i].skuAttrMap) {
                            if (this.sku.items[i].skuAttrMap.hasOwnProperty(key) && tgSkulVm && (!this.chooseTag || this.chooseTag.indexOf(key) !== -1)) {
                                tgSkulVm.pick(key, this.sku.items[i].skuAttrMap[key], 'jsClick');
                            }
                        }
                        break;
                    }
                }
            } else {
                // 是否每一个类型都被选择了
                let isAll = this.skuTags.every((d)=>{
                    return this.chooseTag.indexOf(d) === -1;
                });
                if (!isAll) {
                    // 获取没有被选中的key
                    let noChooseKey = this.skuTags.map((d)=>{
                        if (this.chooseTag.indexOf(d) !== -1) {
                            return d;
                        }
                    });
                    noChooseKey = noChooseKey.filter(item => {
                        return !!item;
                    })
                    // 获取被选中的key和value
                    let chooseObjList = this.skuTags.map((key, index)=>{
                        if (this.chooseTag.indexOf(key) === -1) {
                            return {
                                key: key,
                                val: this.chooseTag[index]
                            };
                        }
                    });
                    chooseObjList = chooseObjList.filter(item => {
                        return !!item;
                    })
                    // 只选中了某个类型
                    for (let i = 0; i < this.sku.items.length; i++) {
                        if (this.sku.items[i].remainQty !== -1 && this.sku.items[i].remainQty !== 0) {
                            // 是否符合已选中的条件
                            let flag = true;
                            for (let j = 0; j < chooseObjList.length; j++) {
                                if (`"${this.sku.items[i].skuAttrMap[chooseObjList[j].key]}"` !== chooseObjList[j].val ) {
                                    flag = false;
                                } else {
                                    break;
                                }
                            }
                            if (flag) {
                                // 逐一选中未选中的类型
                                noChooseKey.forEach(key => {
                                    if (tgSkulVm ) {
                                        tgSkulVm.pick(key, this.sku.items[i].skuAttrMap[key], 'jsClick');
                                    }
                                })
                                break;
                            }
                        }
                    }
                }
            }
            callback(this.skuId, this.skuItem)
        },
        // 确认订单里的sku联动
        chooseSku(tag, val) {
            let tgSkulVm = null;
            if (this.$children) {
                tgSkulVm = this.$children.filter((item) => {
                    return item.$options.name === 'tg-sku';
                })[0];
                if (tag && val) {
                    tgSkulVm.pick(tag, val, 'jsClick');
                }
            }
        }
	}
	, computed: {
		errorHandler(){
			return 'this.src=\''+ this.errImg +'\'';
		}
		, priceText(){
			if( this.showPriceKey === 'skuPrice' ){	// 专柜团加入购物车显示原价
				return this.minSkuPrice +(this.maxSkuPrice ? ('-'+ this.maxSkuPrice) : '');
			}
			return this.minPrice +(this.maxPrice ? ('-'+ this.maxPrice) : '');
		}
		, remainText(){
			if( this.state === '' || this.state === 'findSimilar' ){
				return this.remain === -1 ? '库存充足' : this.remain ? (this.remain > 49 ? '库存充足' : '库存'+ this.remain +'件') : '库存不足';
			}
			else{
				return this.btnText[this.state];
			}
		}
		, chooseText(){
			return !this.chooseTag ? '请选择' : (this.skuTags.length ? '已选' : '');
		}
		, taxText(){
			if( this.taxType !== null ){
				if( MAX_PRICE_EFFECT_TAX_TYPE.indexOf( this.taxType ) !== -1 ){
					return '另付商品税费';
				}
				else{
					return '';
				}
			}
			else{
				return '';
			}
		}
		, taxCount(){
			let rs = 0;
			if( this.taxAmount ){
				return this.taxAmount;
			}

			if( this.tax ){
				rs = Math.ceil(this.tax * (this.price || this.minPrice) * this.skuNum * 100) /100;

				if( !this.price && this.maxPrice ){
					rs += '-'+ Math.ceil(this.tax * this.maxPrice * this.skuNum * 100) /100;
				}

				// if( this.taxType === 0 ){
				// 	if( rs < 50 ){
				// 		rs = '<del>¥'+ rs +'</del>';
				// 	}
				//
				// 	rs += '(<span class="text-green">关税≤50,免征收</span>)';
				// }
				// else{
				// 	rs = '¥'+ rs;
				// }
			}

			return rs;
		}
		, newStoreName(){
			if( this.skuItem ){
				if( this.skuItem.ext && this.skuItem.storeName ){
					return '<i class="icon-parking_info text-red fs-20"></i>' +
						'<div class="lh-20 marginl20 text-left">当前店铺（'+ this.storeName +'）暂时无货' +
						'<br>已为您优选 <span class="text-red">'+ this.skuItem.storeName +'</span></div>'
				}
				else if( this.skuItem.ext ){
					return this.storeName +'无货';
				}
			}
            if (this.storeName) {
                return this.storeName +'提供商品';
            } else {
                return ''
            }
		}
	}
	, watch: {
		price(newVal){
			if( this.priceLimit !== Infinity && MAX_PRICE_EFFECT_TAX_TYPE.indexOf( this.taxType ) !== -1 ){
				if( newVal ){
					this.priceLimitNum = Math.floor( this.priceLimit / newVal ) || 1;
				}
				else{
					this.priceLimitNum = Math.floor( this.priceLimit / (this.maxPrice || this.minPrice) ) || 1;
				}
			}
		}
		, showPriceKey(newVal){
			if( newVal && this.skuItem && newVal +'String' in this.skuItem ){
				this.$set('price', this.skuItem[newVal +'String']);
			}
		}
		, skuItem(newVal){
			if( newVal && newVal.priceString && newVal.skuPriceString && this.counterGroup ){
				this.mainBtnContent = '<span class="fs-12 lh-12">¥'+ newVal.priceString +'</span>'+ this.mainBtnText;
				this.cartBtnContent = '<span class="fs-12 lh-12">¥'+ newVal.skuPriceString +'</span>加入购物车';
			}
		}
	}
	, events: {
		skuComplete: function(tags, skuId, skuNum, skuItem, choose, eventSource){
			if( skuItem ){	// 选中 sku
				this.chooseTag = tags.reduce((all, d)=>{
					all.push( '"'+ skuItem.skuAttrMap[d] +'"' );

					return all;
				}, []);

				this.returnChooseTag = this.chooseTag.slice(0);
			}
			else if( choose ){	// 未选择所有条件
				let i = 0
					;
				this.chooseTag = tags.reduce((all, d)=>{
					if( d in choose ){
						i++;
						all.push( '"'+ choose[d] +'"' );
					}
					else{
						all.push( d );
					}
					return all;
				}, []);

				if( i === 0 ){
					this.returnChooseTag = this.chooseTag = null;
				}
				else if( i === tags.length -1 ){
					this.returnChooseTag = this.chooseTag.slice(0);
				}
				else{
					this.returnChooseTag = null;
				}
			}
			else{
				this.chooseTag = null;
			}
			this.skuTags = tags;

			if( skuItem && skuItem.id ){	// 已确定唯一 sku 数据

				this.$set('skuItem', skuItem);

				if( skuItem.ext ){	// 非当前门店 sku 商品
					if( !skuItem.data ){	// 数据不完整

						this.getSku = true;
						this.state = '';

						request({
							url: domain.baseMidService +'/product/listing/findSameItem.node'
							, data: {
								itemId: this.itemId
								, productId: this.productId
								, productSkuId: skuItem.id
								, activityId: this.activityId
								, groupShow: this.groupShow
							}
							, success: (data)=>{

								this.getSku = false;

								if( data && data.length && data[0].data ){
									data = data[0].data;

									skuItem.data = true;


									let keys = Object.keys(data)
										;

									if( (keys.length === 1 && 'clickUrl' in data) || !('stock' in data) || !('price' in data) ){
										// 有且只有 clickUrl 一个属性时为无货或没有库存或没有价格

										this.findSimilarUrl = data.clickUrl;

										skuItem.realRemain = 0;
										skuItem.remainQty = 0;
										this.$set('remain', 0);
										this.$set('limit', this.limitOriginal);
										this.$set('imgUrl', skuItem.imageUrl || this.mainImgUrl);

										this.state = 'findSimilar';
									}
									else{
										this.skuItem = null;

										data.realRemain = data.stock;
										data.remainQty = data.stock;

										delete data.imageUrl;

										this.skuItem = Object.keys(data).reduce((all, k)=>{

											all[k] = data[k];

											return all;
										}, skuItem);

										this.skuComplete = true;
										this.$set('skuId',skuItem.id);
										this.skuNumLast = this.skuNum;
										this.$set('skuNum', skuNum);

										this.$set('price', skuItem.priceString);
										this.$set('remain', skuItem.remainQty);
										this.$set('imgUrl', skuItem.imageUrl || this.mainImgUrl);
										this.$set('limit', skuItem.limitQty || 0);
										this.num = skuNum;
									}

									this.$broadcast('refreshMaxNum');
								}
								else{
									// 没有相关数据，显示 查看相似商品 按钮
									this.state = 'findSimilar';
								}
							}
						});
					}
					else{	// 数据已获取
						if( skuItem.realRemain === 0 ){
							this.state = 'findSimilar';
						}
						else{
							this.state = '';
							this.$set('skuNum', skuNum);
							this.$set('limit', skuItem.limitQty || 0);
						}
					}
				}
				else{
					this.state = '';
					this.skuComplete = true;
					this.$set('skuId',skuItem.id);
					this.skuNumLast = this.skuNum;
					this.$set('skuNum', skuNum);
					this.$set('vipPrice', skuItem.vipPrice);
					this.$set('price', skuItem[this.showPriceKey +'String']);
					this.$set('remain', skuItem.remainQty);
					this.$set('imgUrl', skuItem.imageUrl || this.mainImgUrl);
					this.$set('limit', this.limitOriginal);
					this.num = skuNum;
                    // 获取预估到手价
                    this.requestProbablyPrice();
				}

				// 是否有税费 获取商品税费
				if( this.hasTax ){
					order.productTax({
						data: {
							products: JSON.stringify([{
								itemId: this.itemId
								, skuId: skuItem.id
								, quantity: skuNum
								, price: this.vipPrice || this.price
							}])
							, storeId: this.storeId
							, bonded: this.bondedItem
							, complex: this.groupItem
						}
						, success: (data)=>{
							this.taxAmount = data.orderItemInfoList[0].taxAmount;

							this.taxType = +!data.postalArticlesTax;
						}
					});
				}
			} else{	// 无效的 sku 或不完整的 sku
				let notAllTag = !!choose && tags.some((tag)=>{
						return !(tag in choose);
					});

				if( !notAllTag ){	// 无效的 sku
					this.state = 'findSimilar';
				} else{	// 不完整的 sku
					this.state = '';
				}

				this.skuComplete = false;
				this.$set('skuId', '');
				this.$set('skuNum', 1);
				this.$set('skuItem', null);
				this.$set('price', '');
				this.$set('remain', this.allRemain);

				if( this.chooseTag ){
					let t = Array.from( new Set(choose.items.map((d)=>{
							return d.imageUrl;
						})) );

					if( t.length === 1 ){
						this.$set('imgUrl', t[0] || this.mainImgUrl);
					}
					else{
						this.$set('imgUrl', this.mainImgUrl);
					}
				} else{
					this.$set('imgUrl', this.mainImgUrl);
				}
				this.num = 1;
			}
            if (this.chooseTag) {
                let colorIndex = tags.findIndex(item => {
                    return item === '颜色分类' || item === '颜色';
                })
                this.$dispatch('changeColorTag', this.chooseTag[colorIndex]);
            } else {
                this.$dispatch('changeColorTag', null);
            }
		}
		, numMax(target, skuNum, type){
			if( this.taxType !== null
				&& MAX_PRICE_EFFECT_TAX_TYPE.indexOf(this.taxType) !== -1
				&& this.priceLimit !== Infinity
				&& this.skuNumLast === skuNum
				&& type === 'plus'
				&& this.price * (skuNum + 1) > this.priceLimit ){

				maple.alert({
					theme: 'tg-alert'
					, content: '根据海关政策要求,商品总价不能超过规定的最高可购限额'+ this.priceLimit +'，请您分别下单'
				});
			}
		},
        // 切换关联品
        changeRelation(id, skuNum) {
            const that = this;
            if (id && id !== this.itemId) {
                this.loadingR = true;
                maple.pageIns.loadMidData({
                    url: domain.baseMidService + '/product/listing/init.node',
                    data: {
                        id,
                        depot: true
                    },
                    format(data) {
                        that.$set('itemId', data.productInfo.itemId);
                        that.$set('btnList', data.btnList);
                        that.skuNum = 1;
                        that.probablyPrice = 0;
                        that.disabled = data.btnList.mainBtn.type === 'disabled';
                        if ('taxRate' in data.productInfo) {
                            that.setTax(data.taxRate, data.taxType, 5000);
                        } else {
                            that.tax = 0;
                            that.taxAmount = 0;
                        }
                        maple.url().replace({
                            id: data.productInfo.itemId
                        });
                        return data;
                    },
                    after() {
                        that.$nextTick(() => {
                            that.loadingR = false;
                        })
                    }
                })
            } else if (skuNum) {
                this.skuNumLast = this.skuNum;
                this.$set('skuNum', skuNum);
                this.num = skuNum;
                if( this.hasTax ){
                    order.productTax({
                        data: {
                            products: JSON.stringify([{
                                itemId: this.itemId
                                , skuId: this.skuItem.productSkuId
                                , quantity: skuNum
                                , price: this.vipPrice || this.price
                            }])
                            , storeId: this.storeId
                            , bonded: this.bondedItem
                            , complex: this.groupItem
                        },
                        success: (data)=>{
                            this.taxAmount = data.orderItemInfoList[0].taxAmount;
                            this.taxType = +!data.postalArticlesTax;
                        }
                    });
                }
            }
        }
	}
};
</script>
